/**
 * 区分 goalStatus（goals.goal_status）
 * 出典：仕様書に値なし
 * 【仮置き】入力文書に値が無い。業務側の確認で差し替える
 */
export const GOAL_STATUS_VALUES = ['notStarted', 'inProgress', 'achieved', 'notAchieved', 'cancelled'] as const;

export type GoalStatus = (typeof GOAL_STATUS_VALUES)[number];

export const GOAL_STATUS_LABELS: Readonly<Record<GoalStatus, string>> = {
  notStarted: '未着手',
  inProgress: '進行中',
  achieved: '達成',
  notAchieved: '未達成',
  cancelled: '中止',
};
